export const text = {
  title: 'Tip of the Month',
  noTipAvailable : 'No Tip Available'
};
